export const getHourPrice = (capacity: number, modelPrice: number, withoutFloating = false) => {
  const price = capacity ? +modelPrice / (capacity / 60 / 60) : +modelPrice;
  if (withoutFloating && price % 1 === 0) {
    return `$${price}`;
  }
  return `$${price >= 100 ? price : price.toFixed(2)}`;
};
